// utils/auth.js
import { stopPushForThisDevice } from "./pushNotifications";

// Several requests can fail together when a login expires: tell the user
// once. The redirect below reloads the app, which resets this.
let isLoggingOut = false;

export const logout = (onLoggedOut) => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  stopPushForThisDevice(); // no more order alerts on this device
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  alert("Session expired. Please log in again.");
  if (onLoggedOut) {
    onLoggedOut(); // React updates isAuthenticated
  }
  setTimeout(() => {
    window.location.href = '/login'; // or use navigate()
  }, 1000);
};



export const getUserRole = () => localStorage.getItem("role");

export const isAdminUser = () => {
  const role = getUserRole();
  return role === "admin" || role === "superAdmin";
};



// export const logout = () => {
//   localStorage.removeItem('token');
//     alert("Session expired. Please log in again.");
//     setTimeout(() => {
//   window.location.href = '/login'; // or automatic redirection to login page
//   }, 1000); // 1 second delay
// };


